import React, { useState } from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

const AboutUs = () => {
  const [formData, setFormData] = useState({
    clientName: '',
    email: '',
    newsletter: false
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ clientName: '', email: '', newsletter: false });
    }, 3000);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="about-page">
      <div className="about-container">
        {/* Registration Section */}
        <section className="registration-section">
          <h2 className="section-heading">How to get awards and recognition for your company?</h2>
          <h3 className="subsection-heading">Get the recognition your broker deserves</h3>
          
          <div className="content-text">
            <p>
              The World Financial Award is recognized by a number of financial organizations, regulators, and non-governmental organizations. 
              Which makes our award one of the most powerful parts of your PR and Marketing strategy. Having the World Financial Award is a strong 
              motivation for your employees, the pride of the brand increases their productivity and engagement with the company. Award also gives 
              dominative position against your competitors.
            </p>

            <p>
              The World Financial Award is one of the most renowned honors an organization can get, just as one of the world's biggest cross-industry, 
              cross fringe business rivalries.
            </p>

            <p>
              Since 2007, we've been remunerating the pioneers, the examples of overcoming adversity, and the moral business people of European business. 
              Not on the grounds that we think it'd be acceptable to give them a congratulatory gesture, a prize. The honours exist since we really accept 
              that business has a vital task to carry out in handling the significant issues looked at by Europe and the world; Unemployment, Climate change, 
              Ongoing clashes, Widespread neediness.
            </p>

            <h4 className="content-subheading">What makes the World Financial Award different?</h4>

            <p>
              Clearly, there is a solid competition for our Awards – they wouldn't merit winning without it. There's additionally a heartiness and 
              straightforwardness to making a decision about the cycle that implies each participant realizes they will be evaluated simply on legitimacy. 
              But at the same time, there's quite a lot more; we attempt to research, run graduated class gatherings, meetings, and online courses that give 
              our locale a wide range of occasions to meet and connect, think and offer.
            </p>

            <p>
              The organizations we draw in and perceive are monetarily fruitful. They comprehend that with the status and force they have comes duty. 
              To look past their own work areas, anterooms, office squares, and nearby networks and have any kind of effect on society on a global level.
            </p>

            <p>
              The World Financial Award (Banking award, Forex broker awards, Insurance awards, Stockbroker awards) brings these similarly invested 
              associations together, giving pioneers from various enterprises an interesting occasion to work together, learn, share and tackle significant 
              difficulties. When else might you be able to get the movers and shakers from drugs and designing, style and transport under a similar rooftop, 
              let be around a similar table!
            </p>

            <p className="important-text">
              To enrol in the 2025 program, fill out the form here.
            </p>

            <p className="important-note">
              <strong>Important:</strong> If you have just enlisted for the 2025 Awards, you don't have to do anything, an individual from (Banking award, 
              Forex broker awards, Insurance awards, Stockbroker awards) our examination group will be in contact with more data once the 2025 Awards are 
              authoritatively open.
            </p>
          </div>
        </section>

        {/* Registration Links */}
        <section className="registration-links">
          <h3 className="section-subheading">About</h3>
          <div className="link-buttons">
            <a href="/register-individual" className="register-link-btn">Individual</a>
            <a href="/register-company" className="register-link-btn">Company</a>
          </div>
        </section>

        {/* Event Information */}
        <section className="event-info-section">
          <p className="event-notice">
            Due to an unusual pandemic situation, the World Financial Award will take part online in 2025. All winners will have opportunities to speak 
            about their strengths, share their knowledge with potential B2B and B2C clients.
          </p>

          <p className="event-description">
            The World Financial Award 2025 award ceremony is a celebration of financial business and its industry professionals.
          </p>

          <h3 className="agenda-heading">Agenda</h3>
          <p className="agenda-note">
            All sessions for WFINA2025 (virtual) are included with your Conference Registration. Pre-Conference Workshops (December 21, 2025) are currently 
            being developed and are not included in your conference registration but are available for purchase at an additional fee, (when available).
          </p>

          <div className="agenda-schedule">
            <div className="agenda-day">
              <h4>December 22, 2025</h4>
              <p><strong>8:30am</strong> General Session: Welcome & Keynote Address</p>
              <p><strong>10:00am-6:00pm</strong> Breakout Sessions, Networking, and Sponsor Gallery</p>
            </div>
            <div className="agenda-day">
              <h4>December 23, 2025</h4>
              <p><strong>9:00am-4:30pm</strong> (Possible Keynote TBD), Breakout Sessions, Networking</p>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="testimonials-section">
          <h3 className="testimonials-heading">Testimonials</h3>
          <blockquote className="testimonial">
            <p>"Keep up the excellent work. We're loving it. World Financial Award is the most valuable business award we have EVER won. This is simply unbelievable!"</p>
            <cite>- Netty N.</cite>
          </blockquote>
        </section>

        {/* Newsletter Registration */}
        <section className="newsletter-section">
          <h3 className="newsletter-heading">Award Registration</h3>
          <form onSubmit={handleSubmit} className="newsletter-form">
            <div className="form-group">
              <input
                type="text"
                name="clientName"
                placeholder="Your Name"
                value={formData.clientName}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="newsletter"
                  checked={formData.newsletter}
                  onChange={handleChange}
                />
                <span>I want to receive newsletters and special offer notices from World Financial Award</span>
              </label>
            </div>
            <button type="submit" className="submit-btn">
              {submitted ? 'Submitted!' : 'Enter'}
            </button>
          </form>
          {submitted && (
            <p className="success-message">Your content has been submitted</p>
          )}
        </section>

        {/* Contact Information */}
        <section className="contact-section">
          <h3 className="contact-heading">Contacts</h3>
          <div className="contact-info">
            <div className="contact-item">
              <Mail className="contact-icon" />
              <span>info@worldfinancialaward.com</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;